const componentStyles = (theme) => ({
  buttonRoot: {
    padding: ".25rem 0 .25rem 1rem!important",
    border: "0!important",
    boxShadow: "none!important",
    [theme.breakpoints.down("md")]: {
      padding: "0!important",
      paddingLeft: "0.5rem!important",
      minWidth: "unset!important",
      borderRadius: "50%",
    },
  },
  buttonLabel: {
    fontSize: ".875rem",
    fontWeight: "600",
    textTransform: "capitalize",
    display: "flex",
    alignItems: "center",
    color: theme.palette.primary.greyBlue,
    [theme.breakpoints.down("md")]: {
      padding: "0!important",
    },
  },
  avatarRoot: {
    width: "36px",
    height: "36px",
    marginRight: "0.5rem",
    [theme.breakpoints.down("md")]: {
      marginRight: "0",
    },
  },
  dividerRoot: {
    height: "0",
    margin: ".5rem 0",
    overflow: "hidden",
    borderTop: "1px solid " + theme.palette.gray[200],
  },
  menuTitle: {
    margin: "0!important",
    textTransform: "uppercase",
    display: "block",
    padding: ".5rem 1rem",
    whiteSpace: "nowrap",
  },
  nestedItem: {
    display: "flex",
    paddingTop: "0.2rem",
    paddingBottom: "0.2rem",
    "&:hover": {
      fontWeight: "900",
      color: theme.palette.white.main + "!important",
      backgroundColor: theme.palette.primary.greyBlue,
      "& .MuiSvgIcon-root": {
        color: theme.palette.white.main
      },
    },
    "&:active": {
      color: theme.palette.white.main,
      backgroundColor: theme.palette.primary.darkBlue,
      "& .MuiSvgIcon-root": {
        color: theme.palette.white.main
      },
    },
  },
});

export default componentStyles;
